import { makeStyles } from '@mui/styles';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const useStyles = makeStyles((theme: any) => ({
  wrapper: {
    textAlign: 'left'
  },
  marginBottom: {
    marginBottom: theme.spacing(2)
  },
  mainContentWrapper: {
    paddingBottom: theme.spacing(2)
  },
  bottomText: {
    marginBottom: theme.spacing(3)
  },
  question: {
    fontWeight: 600
  },
  withIcon: { display: 'flex', alignItems: 'center' }
}));
